/** * Copyright (c) 2025-2099 GitCoffee All Rights Reserved. * * Licensed under
the Apache License, Version 2.0 (the "License"); * you may not use this file
except in compliance with the License. * You may obtain a copy of the License at
* * http://www.apache.org/licenses/LICENSE-2.0 * * Unless required by applicable
law or agreed to in writing, software * distributed under the License is
distributed on an "AS IS" BASIS, * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
either express or implied. * See the License for the specific language governing
permissions and * limitations under the License. */
<template>
  <div class="app-container">
    <a-config-provider :locale="antdLocale" :theme="themeConfig">
      <router-view />
    </a-config-provider>
  </div>
</template>

<style>
/* 先导入主题样式，确保CSS变量先定义 */
@import '@gitcoffee/theme-ui/red.css';
@import './styles/global.css';
</style>

<script setup lang="ts">
import { useAntdLocale, useAppInitialization, useTheme } from '@gitcoffee/app';
import { authManager, useAuth } from '@gitcoffee/auth';
import { Modal } from '@gitcoffee/design-ui';
import { onMounted } from 'vue';
import { APP_SETTING } from './config/config';
import { useSettingsStore } from './stores';

const settingsStore = useSettingsStore();
const { themeConfig, setTheme, setupThemeListener } = useTheme();
const { antdLocale } = useAntdLocale();

const { isInitialized } = useAppInitialization({
  smartSearchDefault: APP_SETTING.smartSearch,
  aiModeSearchDefault: APP_SETTING.aiModeSearch,
  settingsStore,
  onInitialized: () => {
    setTheme();
  },
});

onMounted(async () => {
  await settingsStore.initialize();
  authManager.updateConfig({
    loginConfirmHandler: () => {
      return new Promise((resolve) => {
        Modal.confirm({
          title: '登录提示',
          content: '请登录后继续操作。是否跳转到登录页面？',
          onOk() {
            settingsStore.login();
            resolve(false);
          },
          onCancel() {
            resolve(false);
          }
        });
      });
    },
    loginHandler: () => {
      settingsStore.login();
    }
  });
  
  setTheme();
  setupThemeListener();
});
</script>
